import { ReactNode } from 'react';
import { BoxProps, Box } from '@cad-arc';
export function Mark({ children, style }: { children: ReactNode; style?: BoxProps }) {
    return (
        <Box
            as="mark"
            borderRadius={4}
            bg="interactive.hover"
            color="text.primary"
            style={{ fontWeight: 'bold' }}
            {...style}
        >
            {children}
        </Box>
    );
}
